import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';
import { State, Action, Getter, Mutation } from 'vuex-class';

import Field from '@/../bower_components/teknisavuecomponents/assets/interfaces/Field';
import TkForm from '@/../bower_components/teknisavuecomponents/components/TkForm.vue';
import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';
import DocumentosController from '@/assets/ts/controller/DocumentosController';
import FileUtils from '@/../bower_components/teknisavuecomponents/assets/utils/FileUtils';
import Util from '@/../bower_components/teknisavuecomponents/assets/utils/Util';

import NovaSolicitacaoController from '@/assets/ts/controller/NovaSolicitacaoController';
import AdmissaoController from '@/assets/ts/controller/AdmissaoController';
import DateUtil from '@/../bower_components/teknisavuecomponents/assets/utils/DateUtil';



@Component({
  name: 'NovaFormacaoPopup',
  components: {
    TkForm,
  },
})
class NovaFormacaoPopup extends Vue {
  // #region [ PROPS ]
  @Prop({ default: false })
  private readonly loading: boolean;

  @Prop({ default: undefined })
  private readonly overrideSaveAction: (internalRow: any) => any;

  @Prop({ default: false })
  private readonly row: boolean;

  @Prop({ default: false })
  private readonly value: boolean;
  // #endregion

  // #region [ EVENTS ]
  @Emit('after-save')
  private emitAfterSave() {}

  @Emit('input')
  private emitInput(value: boolean) {}
  // #endregion

  // #region [ DATA ]
  private readonly defaultRow: any = {
    NRTIPOFORMACAO: null,
    NRAREAFORMACAO: null,
  };

  private internalValue = false;

  private internalLoading = {
    tiposFormacao: false,
    cursos: false,
    instituicoes: false,
    areasFormacao: false,
  };

  private internalRow: any = {};

  private fieldsData = {
    tiposFormacao: [],
    cursos: [],
    instituicoes: [],
    areasFormacao: [],
  };
  // #endregion

  // #region [ COMPUTED ]
  private get isLoading(): boolean {
    const loadingValues = Object.values(this.internalLoading);
    const internalLoading = Util.oneTrue(...loadingValues);

    const loading = internalLoading || this.loading;

    return loading;
  }

  private get fields(): Field[] {
    const fields: Field[] = [
      {
        name: 'NRTIPOFORMACAO',
        label: 'Tipo de Formação',
        type: 'autocomplete',
        size: 12,
        required: true,
        descriptionField: 'DSTIPOFORMACAO',
        valueField: 'NRTIPOFORMACAO',
        items: this.fieldsData.tiposFormacao,
        outData: {
          NRTIPOFORMACAO: 'NRTIPOFORMACAO',
          DSTIPOFORMACAO: 'DSTIPOFORMACAO',
        },
      },
      {
        name: 'NRCURSO',
        label: 'Curso',
        type: 'autocomplete',
        size: 6,
        required: true,
        descriptionField: 'NMCURSO',
        valueField: 'NRCURSO',
        items: this.fieldsData.cursos,
        outData: {
          NRCURSO: 'NRCURSO',
          NMCURSO: 'NMCURSO',
        },
      },
      {
        name: 'DSCURSO',
        label: 'Outro Curso',
        type: 'text',
        size: 6,
        required: this.outroCurso,
        readonly: !this.outroCurso,
      },
      {
        name: 'DSINSTITUICAO',
        label: 'Instituição',
        type: 'text',
        size: 12,
        required: true,
      },
      {
        name: 'NRINSTITUICAOPARC',
        label: 'Instituição Estrutura',
        type: 'autocomplete',
        size: 8,
        descriptionField: 'NMPRINCIPALPARC',
        valueField: 'NRPARCNEGOCIO',
        items: this.fieldsData.instituicoes,
        outData: {
          NRINSTITUICAOPARC: 'NRPARCNEGOCIO',
          NMINSTITUICAOPARC: 'NMPRINCIPALPARC',
        },
      },
      {
        name: 'DSANDAMENTOCURSO',
        label: 'Situação do Curso',
        type: 'select',
        size: 4,
        descriptionField: 'NMANDAMENTOCURSO',
        valueField: 'DSANDAMENTOCURSO',
        items: [
          {
            DSANDAMENTOCURSO: 'A',
            NMANDAMENTOCURSO: 'Andamento',
          },
          {
            DSANDAMENTOCURSO: 'P',
            NMANDAMENTOCURSO: 'Paralisado',
          },
          {
            DSANDAMENTOCURSO: 'C',
            NMANDAMENTOCURSO: 'Concluído',
          },
        ],
      },
      {
        name: 'DTINICIO',
        label: 'Início',
        type: 'date',
        size: 3,
        required: true,
      },
      {
        name: 'DTFIM',
        label: 'Fim',
        type: 'date',
        size: 3,
      },
      {
        name: 'NRCARGAHORARIA',
        label: 'Carga Horário (Horas)',
        type: 'number',
        size: 6,
      },
      {
        name: 'NRAREAFORMACAO',
        label: 'Área de Formação',
        type: 'autocomplete',
        size: 6,
        descriptionField: 'NMAREAFORMACAO',
        valueField: 'NRAREAFORMACAO',
        items: this.fieldsData.areasFormacao,
      },
      {
        name: 'DES_AREAFORMACAO_NRORG',
        label: 'Outra Área de Formação',
        type: 'text',
        size: 6,
        required: this.outraArea,
        readonly: !this.outraArea,
      },
      {
        name: 'DSOBSERVACAO',
        label: 'Observação',
        type: 'textarea',
        size: 12,
        rows: 2,
      },
    ];

    return fields;
  }

  private get outroCurso(): boolean {
    const curso = this.internalRow.NRCURSO;
    const isOutro = curso === '2';

    return isOutro;
  }

  private get outraArea(): boolean {
    const area = this.internalRow.NRAREAFORMACAO;
    const isOutra = area === '2';

    return isOutra;
  }
  // #endregion

  // #region [ LIFECYCLE ]
  private created() {
    this.loadFields();
  }
  // #endregion

  // #region [ WATCHERS ]
  @Watch('value', { immediate: true })
  private valueOnChange() {
    this.internalValue = this.value;

    if (this.internalValue) {
      if (this.row == null) {
        this.setDefaultRow();
      } else {
        this.internalRow = Util.deepCopy(this.row);
      }
    }
  }
  // #endregion

  // #region [ METHODS ]
  private closeDialog() {
    this.internalValue = false;
    this.emitInput(this.internalValue);
  }

  private onSave() {
    if (!this.validate()) {
      return;
    }

    if (this.overrideSaveAction) {
      this.overrideSaveAction(this.internalRow);
    } else {
      this.save();
    }
  }

  private async save() {
    //
  }

  private loadFields() {
    this.loadTiposFormacao();
    this.loadCursos();
    this.loadInstituicoes();
    this.loadAreasFormacao();
  }

  private async loadTiposFormacao() {
    this.internalLoading.tiposFormacao = true;

    try {
      this.fieldsData.tiposFormacao =
        await AdmissaoController.getTipoFormacaoParc(false);
    } finally {
      this.internalLoading.tiposFormacao = false;
    }
  }

  private async loadCursos() {
    this.internalLoading.cursos = true;

    try {
      this.fieldsData.cursos =
        await AdmissaoController.getCursoAcademico(false);
    } finally {
      this.internalLoading.cursos = false;
    }
  }

  private async loadInstituicoes() {
    this.internalLoading.instituicoes = true;

    try {
      this.fieldsData.instituicoes =
        await AdmissaoController.getInstituicaoEstrutura(false);
    } finally {
      this.internalLoading.instituicoes = false;
    }
  }

  private async loadAreasFormacao() {
    this.internalLoading.areasFormacao = true;

    try {
      this.fieldsData.areasFormacao =
        await AdmissaoController.getAreaFormacao(false);
    } finally {
      this.internalLoading.areasFormacao = false;
    }
  }

  private setDefaultRow() {
    this.internalRow = Util.deepCopy(this.defaultRow);
  }

  private validate(): boolean {
    if (!this.validateFields()) {
      return false;
    }

    if (!DateUtil.validateDates(this.internalRow.DTINICIO, this.internalRow.DTIFIM)) {
      return false;
    }

    if (!this.validateHoras()) {
      return false;
    }

    return true;
  }

  private validateHoras(): boolean {
    const cargaHoraria: number = this.internalRow.NRCARGAHORARIA;

    if (cargaHoraria <= 0) {
      const message = 'A carga horário deve ser maior que 0 horas!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      return false;
    }

    return true;
  }

  private validateFields(): boolean {
    const isValid: boolean = (this.$refs.form as any).validate(true);

    if (!isValid) {
      const message = 'Preencha todos os campos obrigatórios!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      return;
    }

    return isValid;
  }
  // #endregion
}

export default NovaFormacaoPopup;
